<template>
    <div class="body">
        <header class="header-section">
            <h1 class="main-title">热门课程</h1>
            <h1 class="main-title">🔥持续进化的学习能量</h1>
            <div class="subtitle-wrapper">
                <span class="subtitle-badge">平衡</span>
                <span class="subtitle-badge">关注</span>
                <span class="subtitle-badge">成长</span>
            </div>
        </header>
        <div class="wrapper">
            <div class="course-section">
                <div class="course-grid">
                    <label v-for="(item, index) in topRecommendLink" :key="'hot-' + index"
                        :class="['course-item', { 'is-active': selectedCourses.includes(item.Name) }]">
                        <input type="checkbox" :value="item.Name" v-model="selectedCourses" />
                        <span class="check-mark"></span>
                        <span class="course-name">{{ item.Name }}</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="compulsory-section" v-if="coc && coc.length > 0">
            <h3 class="compulsory-title">必修课程完成情况：</h3>
            <div class="compulsory-grid">
                <!-- 循环生成精致的卡片项 -->
                <div v-for="(item, index) in coc" :key="index" class="compulsory-card">

                    <!-- 课程名称 -->
                    <span class="compulsory-name">{{ item.Name }}</span>

                    <!-- 动态状态胶囊标签 -->
                    <span :class="['status-badge', item.iscompleted ? 'status-done' : 'status-todo']">
                        {{ item.iscompleted ? '已完成' : '未完成' }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        ReportData: { type: Object, required: false },
        selected: { type: Array, default: () => [] }
    },
    data() {
        return {
            topRecommendLink: [],
            selectedCourses: [],
            coc: [],
        }
    },
    created() {
        if (this.ReportData) {
            this.topRecommendLink = JSON.parse(this.ReportData.topRecommendLink || '[]');
        }
        if (this.ReportData.coc !== null) {
            this.coc = JSON.parse(this.ReportData.coc)
            // console.log(this.coc,'coc')
        }
    },
    watch: {
        selectedCourses: {
            deep: true,
            handler(newVal) {
                this.$emit('update:selected', newVal);
            }
        }
    },
    mounted() {
        this.selectedCourses = [...this.selected];
    }
}
</script>

<style scoped>
/* 变量定义 */
:root {
    --primary-green: #2d6a4f;
    --light-green: #d8f3dc;
    --accent-gold: #b78628;
    --text-main: #1b4332;
    --glass-bg: rgba(255, 255, 255, 0.85);
}

.body {
    background:
        url("../../assets/26June/logo.png") right top no-repeat,
        url("../../assets/26June/bg.jpg") no-repeat;
    background-size: 100% 100%, cover;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    /* 禁止全局滚动 */
    color: #333;
    box-sizing: border-box;
    padding: 20px 0;
}

/* 2. 头部：精致化 */
.header-section {
    padding-top: 6vh;
    text-align: center;
    margin-bottom: 15px;
}

.main-title {
    font-size: 24px;
    color: #03584e;
    margin: 0;
    font-weight: 800;
}

.subtitle-wrapper {
    margin-top: 8px;
    display: flex;
    gap: 10px;
    justify-content: center;
}

.subtitle-badge {
    font-size: 14px;
    background: #25726a;
    color: white;
    padding: 2px 10px;
    border-radius: 20px;
    opacity: 0.8;
}

/* 3. 引用卡片：减少空间占用 */
.quote-card {
    width: 88%;
    background: rgba(255, 255, 255, 0.7);
    border-left: 4px solid #42a79d;
    padding: 12px 15px;
    margin-bottom: 20px;
    border-radius: 4px;
}

.p-highlight {
    font-weight: bold;
    color: #03584e;
    margin: 0 0 5px 0;
}

.p-content {
    font-size: 14px;
    color: #666;
    line-height: 1.4;
}

/* 课程列表区域 */
.wrapper {
    width: 90%;
    margin: 0 auto;
}

.course-section {
    background: var(--glass-bg);
    /* padding: 20px; */
    border-radius: 16px;
    /* margin-top: 20px; */
}

.section-title {
    font-size: 1.1rem;
    font-weight: bold;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.section-desc {
    font-size: 0.85rem;
    color: #666;
    margin-bottom: 12px;
}

/* 交互式课程项 */
.course-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.course-item {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    background: #fff;
    border: 1.5px solid #e0e0e0;
    border-radius: 12px;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
}

.course-item input {
    position: absolute;
    opacity: 0;
}

.check-mark {
    width: 20px;
    height: 20px;
    border: 2px solid #ccc;
    border-radius: 50%;
    margin-right: 12px;
    position: relative;
    transition: all 0.3s;
    flex-shrink: 0;
}

.course-item:active {
    transform: scale(0.95);
}

.course-item.is-active {
    border-color: #008777;
    background: #f6f5e4;
    box-shadow: 0 4px 12px rgba(45, 106, 79, 0.1);
}

.course-item.is-active .check-mark {
    background: var(--primary-green);
    border-color: var(--primary-green);
}

.course-item.is-active .check-mark::after {
    content: '✓';
    color: #008777;
    position: absolute;
    left: 4px;
    top: -2px;
    font-size: 14px;
}

.course-name {
    font-size: 0.95rem;
    font-weight: 500;
}

.progress-style {
    border-left: 4px solid var(--accent-gold);
}

/* 交互增强：点击反馈 */
.course-item {
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    /* 增加 Q 弹的贝塞尔曲线 */
}

.course-item:active {
    transform: scale(0.95);
}

/* 必修课程外层大容器 */
.compulsory-section {
    width: 88%;
    margin: 3vh auto 0 auto;
}

/* 标题样式升级 */
.compulsory-title {
    font-size: 16px;
    font-weight: 800;
    color: #03584e;
    /* 延续你的主题墨绿色 */
    margin: 0 0 14px 0;
    padding-left: 4px;
    letter-spacing: 0.5px;
}

/* 课程卡片动态网格 */
.compulsory-grid {
    display: flex;
    flex-direction: column;
    gap: 10px;
    /* 卡片之间的间距 */
}

/* 单个必修课程卡片 */
.compulsory-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 255, 255, 0.75);
    /* 半透明高级感 */
    border: 1px solid rgba(230, 235, 240, 0.8);
    padding: 14px 16px;
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

/* 点击或悬浮时的轻微反馈 */
.compulsory-card:active,
.compulsory-card:hover {
    background: #ffffff;
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(3, 88, 78, 0.06);
}

/* 课程名字样式 */
.compulsory-name {
    font-size: 14px;
    font-weight: 600;
    color: #334155;
    flex: 1;
    padding-right: 15px;
    line-height: 1.4;
}

/* 状态标签通用胶囊样式 */
.status-badge {
    font-size: 12px;
    font-weight: 700;
    padding: 4px 12px;
    border-radius: 30px;
    letter-spacing: 0.5px;
    flex-shrink: 0;
    /* 防止标签被过长的文字挤压变形 */
}

/* 已完成：生机绿 */
.status-done {
    background: #e6f4ea;
    color: #137333;
}

/* 未完成：警戒红（改为“去学习”可以增强互动引导感，也可以保留为“未完成”） */
.status-todo {
    background: #fce8e6;
    color: #c5221f;
    border: 1px solid rgba(197, 34, 31, 0.15);
}

/* ==========================================================================
   针对 PC 宽屏的专属高级响应式适配
   ========================================================================== */
@media screen and (min-width: 786px) {
    .compulsory-section {
        width: 600px;
        /* 锁死 PC 端宽度，防止卡片被横向拉得太长 */
    }

    /* PC 端自动变为精致的【两列并排矩阵】 */
    .compulsory-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }
}

/* 打钩动画 */
.course-item.is-active .check-mark::after {
    animation: popIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes popIn {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

/* PC 端适配 */
@media screen and (min-width: 786px) {
    .body {
        background: url("../../assets/26June/pcbg.png") no-repeat center;
        background-size: cover;
    }

    .quote-card,
    .wrapper {
        width: 600px;
    }

    .course-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
    }
}

.mt-4 {
    margin-top: 24px;
}
</style>